import React, { useState } from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import ShopTierItem from 'src/pages/main/shop/components/ShopExchangeTab/ShopTierItem'
import ShopExchangeItem from 'src/pages/main/shop/components/ShopExchangeTab/ShopExchangeItem'

const TABS = {
  EXCHANGE_LIST: 'exchange_list',
  EXCHANGE_ITEMS: 'exchange_items'
}

const ShopExchangeTab = ({ exchangeData, materialData }) => {
  const listExchange = exchangeData?.items || []
  const remainPoint = exchangeData?.remain_point || 0
  const itemMaterial = materialData?.items || []

  const [activeTab, setActiveTab] = useState(TABS.EXCHANGE_LIST)
  const [selectedItem, setSelectedItem] = useState(null)

  const handleChangeTab = (tab, item = null) => {
    setActiveTab(tab)
    setSelectedItem(item)
  }

  return (
    <div
      className={clsx(
        'flex-1 flex flex-col items-center justify-center gap-4',
        activeTab === TABS.EXCHANGE_ITEMS && 'h-full'
      )}
    >
      {activeTab === TABS.EXCHANGE_LIST &&
        listExchange.map((item) => (
          <ShopTierItem
            key={item.id}
            item={item}
            handleChangeTab={() => handleChangeTab(TABS.EXCHANGE_ITEMS, item)}
          />
        ))}
      {activeTab === TABS.EXCHANGE_ITEMS && (
        <ShopExchangeItem
          itemMaterial={itemMaterial}
          selectedItem={selectedItem}
          remainPoint={remainPoint}
          handleChangeTab={() => handleChangeTab(TABS.EXCHANGE_LIST)}
        />
      )}
    </div>
  )
}

ShopExchangeTab.propTypes = {
  exchangeData: PropTypes.object,
  materialData: PropTypes.object
}

export default ShopExchangeTab
